import { BaseApi, type RequestHeaders, type RequestParams, type PaginatedResponse } from './base';

export interface CannedResponseUploadedFile {
  id: string;
  s3Key?: string;
  originalName: string;
  presignedUrl?: string;
  fileType: string;
  size?: number;
}

export interface CannedResponse {
  _id: string;
  name: string;
  message?: string;
  content?: string;
  file_name?: string;
  file_url?: string;
  file_type?: string;
  uploadedFile?: CannedResponseUploadedFile;
  [key: string]: any;
}

export interface UploadedFileResponse {
  uploadedFileId: string;
  uploadedFileOriginalName: string;
  uploadedFileType: string;
}

class ConversationApi extends BaseApi {
  public constructor() {
    super('conversations');
  }

  /**
   * Get list of canned responses
   * @param {Object} [config] - Optional configuration for the request.
   * @param {RequestParams} [config.params] - Query parameters (e.g., search, pagination).
   * @param {RequestHeaders} [config.headers] - Custom HTTP headers.
   * @returns {Promise<PaginatedResponse<CannedResponse>>}
   */
  public async getCannedFiles({
    params,
    headers,
  }: {
    params?: RequestParams;
    headers?: RequestHeaders;
  } = {}): Promise<PaginatedResponse<CannedResponse>> {
    return this.request<CannedResponse, PaginatedResponse<CannedResponse>>({
      method: 'get',
      url: 'canned-files',
      params,
      headers,
    });
  }

  /**
   * Upload a file to conversations/files.
   * @param file - The file to upload.
   * @returns Promise with uploadedFileId, uploadedFileOriginalName, uploadedFileType.
   */
  public async uploadFile(file: File): Promise<UploadedFileResponse> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await this.request<any, any, FormData>({
      method: 'post',
      url: 'files',
      data: formData,
    });

    const payload = (response && response.data) || response || {};

    return {
      uploadedFileId: payload.uploadedFileId,
      uploadedFileOriginalName: payload.uploadedFileOriginalName,
      uploadedFileType: payload.uploadedFileType,
    };
  }
}

export const conversationApi = new ConversationApi();
